// extracted by mini-css-extract-plugin
module.exports = {"editor":"CodeEditor_editor__XNZB_"};